module.exports = __webpack_public_path__ + "static/img/new2.1bc2daa.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/szrt_revision/teachingDetail/list/mockexamination/imgs/new2.png
// module id = fBJ7
// module chunks = 96